// extracted by mini-css-extract-plugin
export default {"EditDeviceDialog":"EditDeviceDialog_EditDeviceDialog__AL1UR","ErrorMessage":"EditDeviceDialog_ErrorMessage__LIbf3"};